// 별별책방 - 지사 메인페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";
import ReactEcharts from "echarts-for-react";

import { InputGroup } from "react-bootstrap";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import booksStyle from "../components/style";

import CardStatContent from "../components/CardStatContent";
import { isRoleBranch } from "@app/lib/utility";

const ContentBranch = forwardRef(({ isRoleBranch, branchList, statPeriod, selectedCategorySubOption = null, updateViewSubOption, onSelectNursery, branchName, updateMainStat, statAll }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [stat, setStat] = useState(false);
    const [tableData, setTableData] = useState(false);
    const [statPlayCount, setStatOs] = useState(false);
    const [contractList, setContractList] = useState(false);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });

    const playCountContent = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statPlayCount ? statPlayCount.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statPlayCount
                    ? statPlayCount
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${booksStyle.seriesBookColor.normal[idx]};"></span>`}${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: statPlayCount,
                radius: ["0%", "95%"],
                center: ["33%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
                color: booksStyle.seriesBookColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "65%",
            y: "20%",
        },
        sort: false,
        grid: {
            top: "15%",
            left: "5%",
            right: "5",
        },
    };

    const listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "id",
            width: 45,
            minWidth: 45,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "원명",
            headerClass: "bg-dark text-light",
            field: "nurseryName",
            minWidth: 120,
            width: 140,
            resizable: true,
            cellClass: "text-left",
            filter: false,
        },
        {
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">계약 타입</div></div>',
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "tomoContract",
            minWidth: 78,
            width: 90,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">총 계약 수량</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "totalQuan",
            minWidth: 93,
            width: 95,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">동화 계약<br/>부수</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "quanBooks",
            minWidth: 78,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">가입자 수</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "userBooks",
            minWidth: 75,
            width: 75,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">앱 실행</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "cntRun",
            minWidth: 63,
            width: 72,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">콘텐츠<br/> 실행 수</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "totalCount",
            minWidth: 65,
            width: 75,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">집콕</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount1",
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">프리미엄<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount2",
            minWidth: 72,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">기타<br/>동화</div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount3",
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">오디오북<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount4",
            minWidth: 72,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">동요<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount5",
            width: 65,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">AR<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount6",
            width: 65,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">검색<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount7",
            width: 65,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">보관함<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount8",
            minWidth: 61,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">홈<br/></div></div>`,
            },
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            field: "playCount9",
            width: 65,
            resizable: true,
            filter: false,
        },
    ];

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "별별책방_원별통계",
                sheets: [
                    {
                        name: "원",
                        title: `원별 콘텐츠 사용  통계 - ${selectedCategorySubOption}`,
                        columnTitle: [
                            "원 명",
                            "계약 타입",
                            "총 계약 수량",
                            "동화 계약 부수",
                            "가입자 수",
                            "앱 실행",
                            `콘텐츠  실행 수`,
                            `집콕`,
                            `프리미엄동화`,
                            `기타 동화`,
                            `오디오 북`,
                            `동요`,
                            `AR`,
                            `검색`,
                            `보관함`,
                            `홈`,
                        ],
                        data: tableData
                            ? tableData.map((s) => [
                                  s.nurseryName,
                                  s.tomoContract,
                                  s.totalQuan,
                                  s.quanBooks,
                                  s.userBooks,
                                  s.cntRun,
                                  s.totalCount,
                                  s.playCount1,
                                  s.playCount2,
                                  s.playCount3,
                                  s.playCount4,
                                  s.playCount5,
                                  s.playCount6,
                                  s.playCount7,
                                  s.playCount8,
                                  s.playCount9,
                              ])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));
    if (branchName) {
        selectedCategorySubOption = branchName;
    }

    const getStat = () => {
        if (!selectedCategorySubOption) {
            return;
        }
        setStat(null);
        setTableData(null);
        axios({
            method: "POST",
            url: `/api/books_stat/book/branch/nursery/content`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
                limit: -1,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    updateMainStat(result.data.data);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const applyData = (data) => {
        var stat = [];
        const contentCount = data.contentCount;
        const contract = data.contract;

        let playCount = [
            { id: "homeCock", name: "집콕", value: 0 },
            { id: "premiumSong", name: "프리미엄동화", value: 0 },
            { id: "etcSong", name: "기타동화", value: 0 },
            { id: "audioBook", name: "오디오북", value: 0 },
            { id: "song", name: "동요", value: 0 },
            { id: "ar", name: "AR", value: 0 },
            { id: "search", name: "검색", value: 0 },
            { id: "box", name: "보관함", value: 0 },
            { id: "home", name: "홈", value: 0 },
        ];

        var contractList = { nurseryBooks: 0, userBooks: 0, nurseryClass: 0, cntRun: 0, quanBooks: 0, appUseClass: 0 };

        var tableData = [];
        stat = contentCount.map((ct) => {
            var mergeNursery = contract.find((con) => {
                return ct.nurseryUniqId == con.nurseryUniqId;
            });

            if (mergeNursery) {
                var tomoContract;
                if (mergeNursery.tomobooks > 0) tomoContract = "별별책방";
                else if (mergeNursery.tomonote > 0) tomoContract = "토모노트";
                else if (mergeNursery.homebooks > 0) tomoContract = "동화 권한";

                ct.branchName = mergeNursery.branchName;
                ct.nurseryName = mergeNursery.nurseryName;
                ct.tomobooks = mergeNursery.tomobooks;
                ct.quanBooks = mergeNursery.quanBooks;
                ct.cntRun = mergeNursery.cntRun;
                ct.totalQuan = mergeNursery.tomobooks + mergeNursery.tomonote;
                ct.tomoContract = tomoContract;
                ct.userBooks = mergeNursery.userBooks;
            }

            return ct;
        });

        tableData = stat.filter((t) => t.branchName == selectedCategorySubOption);

        tableData.map((t) => {
            playCount[0].value += t.playCount1;
            playCount[1].value += t.playCount2;
            playCount[2].value += t.playCount3;
            playCount[3].value += t.playCount4;
            playCount[4].value += t.playCount5;
            playCount[5].value += t.playCount6;
            playCount[6].value += t.playCount7;
            playCount[7].value += t.playCount8;
            playCount[8].value += t.playCount9;

            contractList.nurseryBooks++;
            contractList.nurseryClass += t.tomobooks;
            contractList.quanBooks += t.quanBooks;
            contractList.userBooks += t.userBooks;
            contractList.cntRun += t.cntRun;
            if (t.cntRun) contractList.appUseClass++;
        });

        setStat(tableData);
        applyTableData(searchParam, tableData);
        setStatOs(playCount);
        setContractList(contractList);
        setTableData(tableData);
    };

    useEffect(() => {
        if(isRoleBranch) {
            setSubOptionApplied(true);
        } else {
            if (!subOptionApplied && updateViewSubOption && branchList && branchList.length > 0) {
                updateViewSubOption(branchList, selectedCategorySubOption || branchList[0].name);
                setSubOptionApplied(true);
            }
        }
        return () => {};
    }, [branchList]);

    useEffect(() => {
        if (subOptionApplied && statPeriod && selectedCategorySubOption && !statAll) {
            getStat();
        }
        return () => {};
    }, [subOptionApplied, statPeriod]);

    useEffect(() => {
        if (statAll) {
            applyData(statAll);
        }
        return () => {};
    }, [statAll, selectedCategorySubOption]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyTableData(searchParam, stat);
    };

    const applyTableData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);
        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = ["nurseryName"];
    const listSearch = (searchParam, list) => {
        var tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                        tableDataNew.push(item);
                    }
                });
            });
        }
        return tableDataNew;
    };

    const onRowSelected = (e) => {
        if (onSelectNursery && e && e.data) {
            onSelectNursery(e.data.nurseryUniqId, e.data.nurseryName, e.data.branchId, e.data.branchName);
        }
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-4">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row mb-5">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatContent id="1" title={`동화 계약 원`} titleTotal="" total={contractList.nurseryBooks} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatContent id="2" title={`동화 계약 클래스`} titleTotal="" total={contractList.nurseryClass} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatContent id="2" title={`동화 계약 부수`} titleTotal="" total={contractList.quanBooks} titleBgClass="bg-tomonote" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`앱 사용 원`} titleTotal="" total={contractList.appUseClass} titleBgClass="bg-tomobooks" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`가입자 수`} titleTotal="" total={contractList.userBooks} titleBgClass="bg-tomobooks" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`앱 실행 수`} titleTotal="" total={contractList.cntRun} titleBgClass="bg-tomoenglish" />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 h-100">
                    <div className="card">
                        <div className="row">
                            <div className="col">
                                <h5 className="card-header stat-content bg-tomoenglish">콘텐츠 실행 수</h5>
                                <div className="card-body" style={{ height: "auto" }}>
                                    <ReactEcharts theme="macarons" option={playCountContent} style={{ height: `180px` }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex"></div>
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="원명"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        columnDefs={listColumn}
                        headerHeight={40}
                        rowData={tableData}
                        onRowClicked={(e) => {
                            onRowSelected(e);
                        }}
                        pagination={true}
                        overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                    />
                </div>
            </div>
        </div>
    );
});

export default ContentBranch;
